import { laceDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/front/lace'
import { laceOfBackOfArroundWebDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/front/lace/arroundWeb'
import { laceOfKnots } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/front/lace/knots'
import { littleMachi } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/front/littleMachi'
import { stitch } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/front/stitch'
import { thumbMachi } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/front/thumbMachi'
import { State } from 'src/types'
import { catchFaceDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/front/catchFace'
import { canvasResetter } from 'src/features/brands/atoms/canvas/common/canvasResetter'
import { webDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/front/web'
import { edgeDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/front/edge'
import { dxmEngravedOfCatchFace } from '../../glove/back/label'

export const dxmCanvasCatcherMittFront = (ctx: CanvasRenderingContext2D, state: State): void => {
  // リセット
  canvasResetter(ctx)
  laceOfKnots(ctx, state.lace.color, 0, 0)
  laceOfBackOfArroundWebDrawer(ctx, state)
  webDrawer(ctx, state)
  catchFaceDrawer(ctx, state)

  thumbMachi(ctx, state.catchFaceTarget.color)
  littleMachi(ctx, state.catchFaceTarget.color)

  edgeDrawer(ctx, state)
  stitch(ctx, state.stitch.color)
  laceDrawer(ctx, state)
  // メーカー捕球面の刻印
  dxmEngravedOfCatchFace(ctx, state.catchFace, 20, 10)
}
